import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getDetailOrderItems } from '../services/orders'

export const getOrderItems = createAsyncThunk('order/getOrderItems', async (orderId) => {
  const params = {
    'fields[user]': 'id,name',
    'include': 'notes,categories,warehouse_item,creator,updater',
    'page[limit]': 100, // FE-1358 will be refractor soon, Maybe :)
  }
  const response = await getDetailOrderItems(orderId, params)
  return response
})

const orderItems = createSlice({
  name: 'order_items',
  initialState: {
    isLoadingOrderItems: true,
    dataOrderItems: []
  },
  reducers: {
    storeOrderItems: (state, action) => {
      state.isLoadingOrderItems = action.payload.isLoadingOrderItems
      state.dataOrderItems = action.payload.dataOrderItems
    },
  },
  extraReducers: {
    [getOrderItems.pending]: (state) => {
      state.isLoadingOrderItems = true
    },
    [getOrderItems.fulfilled]: (state, action) => {
      state.dataOrderItems = setProducts(action.payload)
      state.isLoadingOrderItems = false
    },
    [getOrderItems.rejected]: (state) => {
      state.isLoadingOrderItems = false
    }
  }
})

const setProducts = (payload) => {
  let data = []
  const responseStatus = payload.success
  if (responseStatus) {
    const dataProduct = payload.data
    const included = payload.included

    const getDataUser = (creatorId, included) => {
      let data = null
      const findUser = included[creatorId]
      if (findUser) {
        data = {
          id: findUser.attributes.id,
          name: findUser.attributes.name
        }
      }
      return data
    }

    const findNote = (dataNotes, included, stateNote) => {
      let note = ''
      const includedNote = included.notes
      if (dataNotes.length > 0) {
        const findStateNote = stateNote === 'admin' ? true : false
        const remapNote = dataNotes.map((val) => {
          return includedNote[val.id]
        })
        const findNotes = remapNote.find((val) => val.attributes.is_admin === findStateNote)
        if (findNotes) {
          note = findNotes.attributes.note
        } else {
          note = '-'
        }
      } else {
        note = '-'
      }
      return note
    }

    const findCategoryProduct = (dataCategory, included) => {
      const includedCategories = included.categories
      const remapCategory = dataCategory.map((val) => {
        return includedCategories[val.id].attributes
      })
      return remapCategory
    }

    const findDataTaxes = (data, valueTax) => {
      const dataTax = data.attributes.taxes
      const findDataTax = dataTax.find((val) => val.label === valueTax)
      return findDataTax.value
    }

    const remapDataProduct = dataProduct.map((val) => {
      const getProductNote = val.relationships.notes || []
      const getCategoryProduct = val.relationships.categories || []
      const getWarehouseId = val.relationships.warehouse_item ? val.relationships.warehouse_item.id : null


      return {
        id: val.attributes.id,
        orderId: val.attributes.order_id,
        createdAt: val.attributes.created_at,
        updatedAt: val.attributes.updated_at,

        // Product information
        productId: val.attributes.product_id,
        imageUrl: val.attributes.image_url,
        category: val.attributes.category,
        productName: val.attributes.product_name,
        originalName: val.attributes.original_name,
        originalSku: val.attributes.origin_sku,
        aliSku: val.attributes.ali_sku,
        skuStatus: val.attributes.item_status,
        variants: val.attributes.variants,
        note: val.attributes.note,
        supplierId: val.attributes.supplier_id,
        supplierName: val.attributes.supplier_name,
        warehouse: val.attributes.warehouse,
        originalSourceUrl: val.attributes.original_source_url,
        cityId: val.attributes.city_id,
        cityName: val.attributes.city_name,

        // Pricing
        currency: val.attributes.currency,
        originalPrice: val.attributes.original_price,
        originalPriceType: val.attributes.original_price_type,
        price: val.attributes.cost,
        channelPrice: val.attributes.price,
        weight: val.attributes.item_rule.attributes.weight,
        weightUnit: val.attributes.item_rule.attributes.weight_unit,
        vwDimensionUnit: val.attributes.item_rule.attributes.vw_dimension_unit,
        vwHeight: val.attributes.item_rule.attributes.vw_height,
        vwLength: val.attributes.item_rule.attributes.vw_length,
        vwWidth: val.attributes.item_rule.attributes.vw_width,
        cbm: val.attributes.item_rule.attributes.qty_cbm, // qty_cbm not cbm. will be refractor soon
        cbmPerUnit: val.attributes.item_rule.attributes.cbm_per_unit, // New
        totalCbm: val.attributes.item_rule.attributes.cbm_per_unit * val.attributes.quantity, // New
        hscodes: val.attributes.item_rule.attributes.hscodes,
        quantity: val.attributes.quantity,
        isBundle: false,
        unit_name: val.attributes.unit_name,
        quantity_per_unit: val.attributes.quantity_per_unit,
        base_unit_name: val.attributes.base_unit_name,
        revised_quantity: val.attributes.revised_quantity,
        landed_cost: val.attributes.landed_cost,
        landed_cost_exclude_vat: val.attributes.landed_cost_exclude_vat,
        revised_landed_cost: val.attributes.revised_landed_cost,
        commission_per_sku: val.attributes.commission_per_sku,
        userSellingPrice: 0, // masih belum tau kolomny apa ?
        bm: findDataTaxes(val.attributes.item_rule, 'BM'),
        pph: findDataTaxes(val.attributes.item_rule, 'PPH'),
        ppn: findDataTaxes(val.attributes.item_rule, 'PPN'),
        qtyPacked: val.attributes.qty_packed,

        // include
        adminNote: findNote(getProductNote, included, 'admin'),
        userNote: findNote(getProductNote, included, 'user'),

        // warehouse_item
        warehouse_id: getWarehouseId,

        // categories_id
        categoryProduct: findCategoryProduct(getCategoryProduct, included),

        // show info
        show_info: false,

        // reward point
        reward_point: val.attributes.reward_point,

        creator: val.attributes.created_by ? getDataUser(val.attributes.created_by, included.creator) : null,
        updater: val.attributes.updated_by ? getDataUser(val.attributes.updated_by, included.updater) : null,
      }
    })
    data = remapDataProduct
  } else {
    data = []
  }
  return data
}

export const { storeOrderItems } = orderItems.actions
export default orderItems.reducer